import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Simple initialization with empty resources for now to satisfy the linter
// In a real app, you would load translations from JSON files (e.g. using i18next-http-backend)
i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: {
          "Loading Admin Dashboard...": "Loading Admin Dashboard...",
          "Access Denied": "Access Denied",
          "You do not have permission to view this page.": "You do not have permission to view this page.",
          "Admin Dashboard": "Admin Dashboard",
          "User Directory & Moderation": "User Directory & Moderation",
          "Pending Guides": "Pending Guides",
          "No pending guides to review.": "No pending guides to review.",
          "Guide / Tip": "Guide / Tip",
          "Admin Audit Logs": "Admin Audit Logs",
          "No admin actions have been logged yet.": "No admin actions have been logged yet.",
          "Timestamp": "Timestamp",
          "Admin": "Admin",
          "Action": "Action",
          "Details": "Details",
          "User Activity Logs": "User Activity Logs",
          "No user activities have been logged yet.": "No user activities have been logged yet.",
          "User": "User",
          "Creds": "Creds",
          "Gemini Code Reviewer (Enterprise)": "Gemini Code Reviewer (Enterprise)",
          "Your Code": "Your Code",
          "Reviewing...": "Reviewing...",
          "Review Code": "Review Code",
          "Gemini's Feedback": "Gemini's Feedback",
          "Gemini is thinking...": "Gemini is thinking...",
          "Analyzing your code for quality and improvements.": "Analyzing your code for quality and improvements.",
          "Ready for Review": "Ready for Review",
          "Your code review feedback will appear here once you submit your code.": "Your code review feedback will appear here once you submit your code.",
          "Error: ": "Error: "
        }
      }
    },
    lng: "en",
    fallbackLng: "en",
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;
